import { IFacialRecognitionProcess } from 'shared/domain/entities/facialRecognition';

interface IConstructor {
  unitId: number;
  customerId: number;
  flow: string;
}

export class VectisScheduleFacialRecognitionProcess
  implements IFacialRecognitionProcess
{
  public type: IFacialRecognitionProcess['type'] = 'VECTIS_SCHEDULE';
  public url: IFacialRecognitionProcess['url'];
  public key: IFacialRecognitionProcess['key'];
  public params: IFacialRecognitionProcess['params'];
  public trackingPayload: IFacialRecognitionProcess['trackingPayload'];

  constructor({ unitId, customerId, flow }: IConstructor) {
    this.url = `/caf/onboarding/${customerId}`;
    this.trackingPayload = {
      tipo: flow,
      idUnidade: unitId,
      idCliente: customerId,
    };
    this.key = [this.type, String(customerId), String(unitId)];
    this.params = {
      idUnidade: unitId,
      tipoFluxo: flow,
    };
  }
}
